export function initialize() {
  if ('IntersectionObserver' in window) {
    let observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(el) {
        if (el.intersectionRatio > 0) {
          el.target.style.transform = 'scale(1.0)'
          el.target.style.opacity = '1'
        } else {
          el.target.style.transform = 'scale(0.9)'
          el.target.style.opacity = '0'
          el.target.style.transitionDuration = '0.5s, 0.75s'
          el.target.style.transitionProperty = 'transform, opacity'
          el.target.style.transitionTimingFunction = 'ease-out, ease-out'
        }
      })
    }, {
      // These dimensions mean:
      // * 190px down from the top; this is our standard 100px, plus the height of the fixed header
      // * 0px from the right
      // * 100px up from the bottom
      // * 0px from the left
      rootMargin: '-190px 0px -100px 0px'
    })
    document.querySelectorAll('.fadable').forEach(function(targetEl) {
      observer.observe(targetEl)
    })
  }
}
